// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"74":"About","268":"Home","320":"Bibliography","540":"Navigation","573":"Exhibitions","646":"Addresses","786":"Conference","945":"Video"}[chunkId] + "-legacy." + {"74":"6ea55bc6","268":"085d6678","320":"909a6a9d","540":"3e72229f","573":"d805c508","646":"4f9e2a84","786":"d5725531","945":"406bb005"}[chunkId] + ".js";
};